import { IconsProps } from '@/types/shared'
import React from 'react'

const GenderIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-mars-icon lucide-mars"
            >
                <path d="M16 3h5v5" />
                <path d="m21 3-6.75 6.75" />
                <circle cx="10" cy="14" r="6" />
            </svg>
        </div>
    )
}

export default GenderIcons
